import { useAuth } from './AuthContext';
import { isDevModeAllowed } from '../utils/devModeEnabled';

/**
 * useIsAdmin
 *
 * Returns true when the authenticated user carries the 'Admin' role claim
 * in their B2C ID token (checked via idTokenClaims.roles or
 * idTokenClaims.extension_Roles).
 *
 * In DevMode the hook always returns true so the admin shell renders
 * without a real token. Defense-in-depth: the DevMode shortcut only applies
 * in builds where devmode is allowed (VITE_ALLOW_DEVMODE / vite dev) — in
 * prod builds isDevMode can never grant admin.
 */
export function useIsAdmin(isDevMode: boolean): boolean {
  const { user } = useAuth();
  if (isDevMode && isDevModeAllowed()) return true;
  return user?.isAdmin ?? false;
}
